import * as THREE from 'three';
import {FBXLoader} from 'three/examples/jsm/loaders/FBXLoader.js';
import {EXRLoader} from 'three/examples/jsm/loaders/EXRLoader.js';

export const vertexShader = require('../shader/vertexShader.glsl');
export const fragmentShader = require('../shader/fragmentShader.glsl');
export const devVert = require('../shader/devVert.glsl');
export const devFra = require('../shader/devFra.glsl');
export const vatChunk = require('../shader/vatChunk.glsl');
export const vatNormalChunk = require('../shader/vatNormalChunk.glsl');
export const vatDepthChunk = require('../shader/vatDepthChunk.glsl');
export const poyonFragChunk  = require('../shader/poyonFragChunk.glsl');
export const poyonFragPars   = require('../shader/poyonFragPars.glsl');
export const poyon2FragChunk = require('../shader/poyon2FragChunk.glsl');
export const poyon0FragChunk = require('../shader/poyon0FragChunk.glsl');
// const dataName ='high/Poyon0'
const dataName ='Poyon0'
export default class Poyon {
    private _geometry: THREE.BufferGeometry | null = null;
    private _positionTex: THREE.Texture | null = null;
    private _normalTex: THREE.Texture | null = null;
    private _material: THREE.ShaderMaterial;
    private _mesh: THREE.Mesh;
    public time: number=0;
    private scene: THREE.Scene;
    private camera: THREE.PerspectiveCamera;
    private FBXLoader = new FBXLoader();
    private EXRLoader = new EXRLoader();
    private _data;
    private _index;
    private _w: number = 500;
    private _h: number = 500;
    private _uScale: number = 10;
    private model:string ='';
    private bin:string='';
    private nrm:string='';
    private _mouse = new THREE.Vector2();
    private _raycaster = new THREE.Raycaster();

    private _shaderRef: any = null;
    private _depthShaderRef: any = null;
    private _contactShadowShaderRef: any = null;
    private _noMatMaterial: THREE.MeshNormalMaterial | null = null;
    private _wireMaterial = new THREE.MeshBasicMaterial({ color: 0x111111, wireframe: true });
    private _viewMode: 'normal' | 'wireframe' | 'noMaterial' = 'normal';

    public _timeSpeed: number = 0.5;
    public _firstLoop: boolean = true; // 1ループ目はラップしない
    public _hueOffset: number = 0; // 同マテリアルタイプ内での色相オフセット（0〜1）
    public _variant: number = 0; // 同 _index 内のバリアント (0 or 1)。色相と質感を切替えて重複感を解消
    public _mood: 'quiet' | 'soft' | 'mid' | 'vivid' = 'mid';
    // 'quiet'=ほぼ白 / 'soft'=柔らかいパステル / 'mid'=ほどほどカラフル / 'vivid'=ド派手

    // ループごとの色プリセット（全インデックス共通）
    // index 0 (marble):  cyan / blue / pink / light
    // index 1 (sheen):   color / sheenColor
    // index 2 (spotty):  light / deep / sharpness
    public _wrapPeriod: number = 0;
    private _loopWrapCount: number = 0;
    private _instanceSeed: number = 0; // 個体ごとの固有シード
    private _isMilky: boolean = false; // index 0 用: 20個に1個の低頻度で乳白色寄り
    private _loopPresets: Array<{
        cyan?: string; blue?: string; pink?: string;
        color?: string; sheenColor?: string;
        light?: string; deep?: string; sharpness?: number;
    }> = [
        { light: '#FFDCF0', deep: '#C030A8', sharpness: 0.2 },
        { light: '#098278', deep: '#34cf2c', sharpness: 0.47 },
        { light: '#eb1e9b', deep: '#c6c80d', sharpness: 0.37 },
    ];

    private _ripples: {pos: THREE.Vector3, time: number, active: boolean}[] = Array.from({length: 5}, () => ({pos: new THREE.Vector3(), time: 0, active: false}));
    public _lastTime: number = performance.now();

    public _dataIndex: number; // 読み込むFBX/EXRのindex（_indexとは別）

    constructor(scene: THREE.Scene, index: number, camera, dataIndex?: number, variant: number = 0, mood: 'quiet' | 'soft' | 'mid' | 'vivid' = 'mid') {
        this.scene = scene;
        this.camera = camera;
        this._index = index;
        this._dataIndex = dataIndex ?? index;
        this._variant = variant;
        this._mood = mood;
        this._uScale = 15.;
        this._instanceSeed = Math.floor(Math.random() * 100000);
        // index 0 用: 20個に1個の低頻度で乳白色寄りモード（デフォルトは透明）
        this._isMilky = Math.random() < 0.05;
        this.time = 0;
        this._w=window.innerWidth
        this._h=window.innerHeight
        this._doInit();

    }

    async _doInit() {
        await this._fetchJSON();
        this._wrapPeriod = this._data.frameCount;
        // interval = wrapPeriod / total にすることでグループ間ギャップなし
        this.time = 0; // 全ポヨン画面外（アニメーション起点）からスタート
        this.model = `/data/poyons/${dataName}${this._dataIndex+1}.fbx`;
        this.bin = `/data/poyons/${dataName}${this._dataIndex+1}_pos.bin`;
        this.nrm= `/data/poyons/${dataName}${this._dataIndex+1}_nrm.bin`;
        // this.loadBin();
        this.loadEXR();
        this.loadGLB();
    }
    getMesh(): THREE.Mesh { return this._mesh; }
    getCenter(): THREE.Vector3 {
        const min = this._data['min'];
        const max = this._data['max'];
        return new THREE.Vector3(
            (min[0] + max[0]) / 2 * this._uScale,
            (min[1] + max[1]) / 2 * this._uScale,
            (min[2] + max[2]) / 2 * this._uScale,
        );
    }

    async _fetchJSON(){
        const res = await fetch(`../../data/poyons/${dataName}${this._dataIndex+1}_bounds.json`);
        this._data = await res.json();
    }
    setCursorWorld(pos: THREE.Vector3, active: number = 1.0) {
        if (this._shaderRef) {
            this._shaderRef.uniforms.uCursorWorld.value.copy(pos);
            this._shaderRef.uniforms.uCursorActive.value = active;
        }
    }
    addRipple(pos: THREE.Vector3) {
        const slot = this._ripples.findIndex(r => !r.active);
        if (slot === -1) return;

        this._ripples[slot] = { pos: pos.clone(), time: 0, active: true };

        if (this._shaderRef) {
            this._shaderRef.uniforms.uRipplePos.value[slot].copy(pos);
            this._shaderRef.uniforms.uRippleTime.value[slot]   = 0;
            this._shaderRef.uniforms.uRippleActive.value[slot] = 1;
        }
    }
    loadBin() {
        // fetch(this.bin)
        //     .then(res => res.arrayBuffer())
        //     .then(buffer => {
        //         const data = new Float32Array(buffer);
        //
        //         const width  = this._data.vertexCount;
        //         const height = this._data.frameCount;
        //         const floatTex = new THREE.DataTexture(
        //             data,
        //             width,
        //             height,
        //             THREE.RGBAFormat,
        //             THREE.FloatType,
        //         );
        //         floatTex.minFilter      = THREE.NearestFilter;
        //         floatTex.magFilter      = THREE.NearestFilter;
        //         floatTex.generateMipmaps = false;
        //         floatTex.flipY          = false;
        //         floatTex.colorSpace     = THREE.NoColorSpace;
        //         floatTex.needsUpdate    = true;
        //
        //         this._positionTex = floatTex;
        //         this.tryInit();
        //     });

        const binPos = fetch(this.bin).then(r => r.arrayBuffer());
        const binNrm = fetch(this.nrm).then(r => r.arrayBuffer());
        Promise.all([binPos, binNrm]).then(([posBuffer, nrmBuffer]) => {
            const posData = new Float32Array(posBuffer);
            const nrmData = new Float32Array(nrmBuffer);

            const width  = this._data.vertexCount;
            const height = this._data.frameCount;

            const makeTex = (data: Float32Array) => {
                const tex = new THREE.DataTexture(
                    data, width, height,
                    THREE.RGBAFormat,
                    THREE.FloatType,
                );
                tex.minFilter      = THREE.NearestFilter;
                tex.magFilter      = THREE.NearestFilter;
                tex.generateMipmaps = false;
                tex.flipY          = false;
                tex.colorSpace     = THREE.NoColorSpace;
                tex.needsUpdate    = true;
                return tex;
            };

            this._positionTex = makeTex(posData);
            this._normalTex   = makeTex(nrmData);
            this.tryInit();
        });
    }

    private loadGLB() {
        this.FBXLoader.load(this.model, (object) => {
            object.traverse((child: any) => {
                // console.log('child',child);
                if (child.isMesh) {
                    this._geometry = child.geometry.clone();
                    const uv = this._geometry.attributes.uv;
                    const count = uv.count;
                    const vatU = new Float32Array(count);

                    for (let i = 0; i < count; i++) {
                        vatU[i] = uv.getX(i);
                    }

                    this._geometry.setAttribute(
                        'aVatU',
                        new THREE.BufferAttribute(vatU, 1)
                    );

                    // console.log('vatU sample:', vatU[0], vatU[1], vatU[2]);
                    // → 0〜1の値が入っていればOK
                }
            });
            // console.log('this._geometry',this._geometry);
            // this.addVertexId(this._geometry);
            this.tryInit();
        });
    }
    loadEXR() {
        const loadEXR = (url: string): Promise<THREE.DataTexture> => {
            return new Promise((resolve) => {
                this.EXRLoader.load(url, (texture) => {
                    const raw = texture.image.data;
                    const width = texture.image.width;
                    const height = texture.image.height;

                    let data: Float32Array;
                    if (raw instanceof Uint16Array) {
                        // Half Float → Float32 変換
                        data = new Float32Array(raw.length);
                        for (let i = 0; i < raw.length; i++) {
                            data[i] = this.decodeHalfFloat(raw[i]);
                        }
                    } else {
                        data = raw as Float32Array;
                    }

                    const tex = new THREE.DataTexture(
                        data, width, height,
                        THREE.RGBAFormat,
                        THREE.FloatType,
                    );
                    tex.minFilter      = THREE.NearestFilter;
                    tex.magFilter      = THREE.NearestFilter;
                    tex.generateMipmaps = false;
                    tex.flipY          = false;
                    tex.colorSpace     = THREE.NoColorSpace;
                    tex.needsUpdate    = true;
                    resolve(tex);
                });
            });
        };

        Promise.all([
            loadEXR(`/data/poyons/${dataName}${this._dataIndex+1}_pos.exr`),
            loadEXR(`/data/poyons/${dataName}${this._dataIndex+1}_nrm.exr`),
        ]).then(([posTex, nrmTex]) => {
            this._positionTex = posTex;
            this._normalTex   = nrmTex;
            this.tryInit();
        });
    }

    decodeHalfFloat(val: number): number {
        const s = (val & 0x8000) >> 15;
        const e = (val & 0x7C00) >> 10;
        const f =  val & 0x03FF;
        if (e === 0)  return (s ? -1 : 1) * Math.pow(2, -14) * (f / 1024);
        if (e === 31) return f ? NaN : (s ? -Infinity : Infinity);
        return (s ? -1 : 1) * Math.pow(2, e - 15) * (1 + f / 1024);
    }

    private tryInit() {

        if (!this._geometry || !this._positionTex || !this._normalTex) return;

        this.initMesh();
    }

    private initMesh() {
        const min = this._data['min'];
        const max = this._data['max'];

        // this._material = new THREE.ShaderMaterial({
        //     uniforms: {
        //         uPositionTex: {value: this._positionTex},
        //         uNormalTex: { value: this._normalTex },
        //         uTime: {value: 2.},
        //         uWindowSize:{value: new THREE.Vector2(this._w,this._h)},
        //         // uTotalFrames: {value: frames},
        //
        //         uMouseWorld: { value: new THREE.Vector3(0, 0, 0) },
        //
        //         uMouseStokers: { value: [
        //                 new THREE.Vector3(),
        //                 new THREE.Vector3(),
        //                 new THREE.Vector3(),
        //                 new THREE.Vector3(),
        //                 new THREE.Vector3(),
        //             ]},
        //
        //         uMin: { value: new THREE.Vector3(min[0], min[1], min[2]) },
        //         uMax: { value: new THREE.Vector3(max[0], max[1], max[2]) },
        //
        //         uScale: { value: this._uScale},
        //         uTexSize: { value: new THREE.Vector2(this._data.vertexCount, this._data.frameCount) }
        //         // uTexSize: { value: new THREE.Vector2(this._positionTex.image.width, this._positionTex.image.height) }
        //     },
        //     vertexShader,
        //     fragmentShader,
        //     side: THREE.DoubleSide,
        //     wireframe: false,
        // });
        // 個体ごとのランダムヘルパー
        const _fract = (v: number) => v - Math.floor(v);
        const _hash  = (s: number, salt: number) => _fract(Math.sin(s * 127.1 + salt) * 43758.545);
        const _vary  = (base: number, range: number) => base + ((_hash(this._instanceSeed, base * 7.3) - 0.5) * 2) * range;

        if (this._index === 0) {
            // マテリアル1: 透明マーブル — variantで質感を分岐
            if (this._isMilky) {
                // 乳白色寄り（レア・20個に1個）
                this._material = new THREE.MeshPhysicalMaterial({
                    color: 0xffffff,
                    roughness: _vary(0.20, 0.10),
                    metalness: 0.0,
                    transmission: _vary(0.45, 0.15),
                    ior: _vary(1.52, 0.18),
                    thickness: _vary(120.0, 40.0),
                    clearcoat: _vary(0.55, 0.30),
                    clearcoatRoughness: _vary(0.20, 0.12),
                    envMapIntensity: _vary(0.9, 0.30),
                    wireframe: false,
                }) as any;
            } else {
                // 透明（デフォルト・色がしっかり見える設定）
                this._material = new THREE.MeshPhysicalMaterial({
                    color: 0xffffff,
                    roughness: _vary(0.06, 0.05),
                    metalness: 0.0,
                    transmission: _vary(0.55, 0.15),
                    ior: _vary(1.42, 0.20),
                    thickness: _vary(80.0, 30.0),
                    clearcoat: _vary(0.85, 0.20),
                    clearcoatRoughness: _vary(0.06, 0.06),
                    envMapIntensity: _vary(1.2, 0.4),
                    wireframe: false,
                }) as any;
            }
        } else if (this._index === 1) {
            // マテリアル2: シーン — variantで色相と質感を分岐
            // 初期色は共通ヘルパーで生成（白+薄色 / パステル / ビビッドを混在）
            const [col, sCol] = this._generatePaletteFromSeed(this._instanceSeed, 2);
            if (this._variant === 0) {
                // variant 0: 柔らかいシーン (sheen強め・metalness低め)
                this._material = new THREE.MeshPhysicalMaterial({
                    color: col,
                    roughness: _vary(0.55, 0.15),
                    metalness: _vary(0.1, 0.08),
                    sheen: _vary(0.8, 0.2),
                    sheenRoughness: _vary(0.6, 0.2),
                    sheenColor: sCol,
                    envMapIntensity: _vary(0.6, 0.2),
                    wireframe: false,
                }) as any;
            } else {
                // variant 1: 金属感のある光沢 (sheen無し・metalness高め)
                this._material = new THREE.MeshPhysicalMaterial({
                    color: col,
                    roughness: _vary(0.30, 0.10),
                    metalness: _vary(0.55, 0.10),
                    sheen: 0.0,
                    sheenRoughness: 0.5,
                    sheenColor: sCol,
                    clearcoat: _vary(0.4, 0.2),
                    clearcoatRoughness: _vary(0.15, 0.05),
                    envMapIntensity: _vary(1.2, 0.2),
                    wireframe: false,
                }) as any;
            }
        } else if (this._index === 2) {
            // マテリアル3: スポット柄 — variantで質感を分岐
            if (this._variant === 0) {
                // variant 0: ツヤあり (既存)
                this._material = new THREE.MeshPhysicalMaterial({
                    color: 0xffffff,
                    roughness: _vary(0.25, 0.15),
                    metalness: 0.0,
                    clearcoat: _vary(0.6, 0.3),
                    clearcoatRoughness: _vary(0.05, 0.03),
                    envMapIntensity: _vary(0.8, 0.2),
                    wireframe: false,
                }) as any;
            } else {
                // variant 1: マット寄り (clearcoat無し・roughness高め)
                this._material = new THREE.MeshPhysicalMaterial({
                    color: 0xffffff,
                    roughness: _vary(0.75, 0.10),
                    metalness: 0.0,
                    clearcoat: 0.0,
                    clearcoatRoughness: 0.0,
                    envMapIntensity: _vary(0.4, 0.15),
                    wireframe: false,
                }) as any;
            }
        } else {
            this._material = new THREE.MeshStandardMaterial({color: 0xffffff, roughness: 0.5, metalness: 0.0, envMapIntensity: 0.5}) as any;
        }

        this._material.onBeforeCompile = (shader) => {
            shader.uniforms.uPositionTex = {value: this._positionTex};
            shader.uniforms.uNormalTex = {value: this._normalTex};
            shader.uniforms.uTime = {value: 2.};
            shader.uniforms.uWindowSize = {value: new THREE.Vector2(this._w, this._h)};
            shader.uniforms.uCursorWorld = {value: new THREE.Vector3(0, 0, 0)};
            shader.uniforms.uCursorActive = {value: 1.0};
            shader.uniforms.uMin = {value: new THREE.Vector3(min[0], min[1], min[2])};
            shader.uniforms.uMax = {value: new THREE.Vector3(max[0], max[1], max[2])};
            shader.uniforms.uScale = {value: this._uScale};
            shader.uniforms.uTexSize = {value: new THREE.Vector2(this._data.vertexCount, this._data.frameCount)};
            shader.uniforms.uRipplePos = {value: Array.from({length: 5}, () => new THREE.Vector3())};
            shader.uniforms.uRippleTime = {value: new Float32Array(5)};
            shader.uniforms.uRippleActive = {value: new Float32Array(5)};
            shader.uniforms.uRippleSpeed    = {value: 12.0};
            shader.uniforms.uRippleRadius   = {value: this._w};
            shader.uniforms.uRippleStrength = {value: 14.0};
            shader.uniforms.uRippleWidth    = {value: 90.0};
            shader.vertexShader = `
            uniform sampler2D uPositionTex;
            uniform sampler2D uNormalTex;
            uniform float uTime;
            uniform vec2 uTexSize;
            uniform vec2 uWindowSize;
            uniform vec3 uCursorWorld;
            uniform float uCursorActive;
            uniform vec3 uMin;
            uniform vec3 uMax;
            uniform float uScale;
            attribute float aVatU;

            varying vec3 vWorldPos;
            varying vec3 vObjectPos;

            uniform vec3  uRipplePos[5];
            uniform float uRippleTime[5];
            uniform float uRippleActive[5];
            uniform float uRippleSpeed;
            uniform float uRippleRadius;
            uniform float uRippleStrength;
            uniform float uRippleWidth;
        ` + shader.vertexShader;

            // begin_vertex を vatChunk で置き換え
            shader.vertexShader = shader.vertexShader.replace(
                '#include <begin_vertex>',
                vatChunk,
            );

            // beginnormal_vertex を vatNormalChunk で置き換え
            shader.vertexShader = shader.vertexShader.replace(
                '#include <defaultnormal_vertex>',
                vatNormalChunk,
            );
        //     shader.fragmentShader = shader.fragmentShader.replace(
        //         '#include <dithering_fragment>',
        //         `
        // gl_FragColor = vec4(vNormal * 0.5 + 0.5, 1.0);
        // `
        //     );
            // vWorldPos をワールド空間でセット
            shader.vertexShader = shader.vertexShader.replace(
                '#include <project_vertex>',
                `#include <project_vertex>
                vWorldPos = (modelMatrix * vec4(transformed, 1.0)).xyz;
                vObjectPos = position;`
            );

            // index 0: 3色マーブル — 初期色を個体シードで生成
            if (this._index === 0) {
                const [initCyan, initBlue, initPink] = this._generateBlobPalette(this._instanceSeed);
                shader.uniforms.uColorCyan = { value: initCyan };
                shader.uniforms.uColorBlue = { value: initBlue };
                shader.uniforms.uColorPink = { value: initPink };
                shader.fragmentShader = shader.fragmentShader.replace(
                    '#include <common>',
                    `#include <common>\n${poyonFragPars}`
                );
                shader.fragmentShader = shader.fragmentShader.replace(
                    '#include <color_fragment>',
                    poyon0FragChunk,
                );
                // totalEmissiveRadiance は color_fragment より後で宣言されるため
                // emissivemap_fragment のタイミングで注入する
                shader.fragmentShader = shader.fragmentShader.replace(
                    '#include <emissivemap_fragment>',
                    `totalEmissiveRadiance = diffuseColor.rgb * 0.80;`
                );
            }
            // index 2: まだら — 初期色を共通ヘルパーで生成（ムード混在）
            if (this._index === 2) {
                const [lightCol, deepCol] = this._generatePaletteFromSeed(this._instanceSeed, 2);
                shader.uniforms.uColorLight    = { value: lightCol };
                shader.uniforms.uColorDeep     = { value: deepCol };
                // variant 1 はsharpness高めで模様コントラストを強める
                const sharpBase = this._variant === 0 ? 0.4 : 0.75;
                shader.uniforms.uSpotSharpness = { value: _vary(sharpBase, 0.15) };
                shader.fragmentShader = shader.fragmentShader.replace(
                    '#include <common>',
                    `#include <common>\n${poyonFragPars}\nuniform float uSpotSharpness;`
                );
                shader.fragmentShader = shader.fragmentShader.replace(
                    '#include <color_fragment>',
                    poyon2FragChunk,
                );
            }

            // index 0（透明ポヨン）のみ: エッジの黒縁を背景色にブレンド
            if (this._index === 0) {
                shader.fragmentShader = shader.fragmentShader.replace(
                    '#include <dithering_fragment>',
                    `#include <dithering_fragment>
                    vec3 _bgColor = vec3(0.9412, 0.9098, 0.8627); // 0xF0E8DC
                    vec3 _N2 = normalize(vNormal);
                    vec3 _V2 = normalize(vViewPosition);
                    float _edge = 1.0 - max(dot(_N2, _V2), 0.0);
                    float _edgeMask = smoothstep(0.75, 1.0, _edge);
                    gl_FragColor.rgb = mix(gl_FragColor.rgb, _bgColor, _edgeMask);`
                );
            }

            // console.log(shader.vertexShader.includes('#include <beginnormal_vertex>'));

            this._shaderRef = shader;
        };

        this._material.customProgramCacheKey = () => `poyon_vat_${this._index}_${this._variant}`;
        this._mesh = new THREE.Mesh(this._geometry!, this._material);
        this._mesh.castShadow = true;
        this._mesh.receiveShadow = true;
        this._noMatMaterial = new THREE.MeshNormalMaterial();

        // VAT対応のカスタムデプスマテリアル（シャドウパス用）
        const depthMat = new THREE.MeshDepthMaterial({
            depthPacking: THREE.RGBADepthPacking,
        });
        depthMat.onBeforeCompile = (shader) => {
            shader.uniforms.uPositionTex = { value: this._positionTex };
            shader.uniforms.uTime        = { value: 2. };
            shader.uniforms.uTexSize     = { value: new THREE.Vector2(this._data.vertexCount, this._data.frameCount) };
            shader.uniforms.uMin         = { value: new THREE.Vector3(min[0], min[1], min[2]) };
            shader.uniforms.uMax         = { value: new THREE.Vector3(max[0], max[1], max[2]) };
            shader.uniforms.uScale       = { value: this._uScale };

            shader.vertexShader = `
            uniform sampler2D uPositionTex;
            uniform float uTime;
            uniform vec2 uTexSize;
            uniform vec3 uMin;
            uniform vec3 uMax;
            uniform float uScale;
            attribute float aVatU;
            ` + shader.vertexShader;

            shader.vertexShader = shader.vertexShader.replace(
                '#include <begin_vertex>',
                vatDepthChunk,
            );

            this._depthShaderRef = shader;
        };
        depthMat.customProgramCacheKey = () => `poyon_depth_${this._index}`;
        this._mesh.customDepthMaterial = depthMat;

        // ContactShadow用: VAT頂点シェーダー + 黒出力
        const contactShadowMat = new THREE.MeshBasicMaterial({ color: 0x000000 });
        contactShadowMat.onBeforeCompile = (shader) => {
            shader.uniforms.uPositionTex = { value: this._positionTex };
            shader.uniforms.uTime        = { value: 2. };
            shader.uniforms.uTexSize     = { value: new THREE.Vector2(this._data.vertexCount, this._data.frameCount) };
            shader.uniforms.uMin         = { value: new THREE.Vector3(min[0], min[1], min[2]) };
            shader.uniforms.uMax         = { value: new THREE.Vector3(max[0], max[1], max[2]) };
            shader.uniforms.uScale       = { value: this._uScale };
            shader.vertexShader = `
            uniform sampler2D uPositionTex;
            uniform float uTime;
            uniform vec2 uTexSize;
            uniform vec3 uMin;
            uniform vec3 uMax;
            uniform float uScale;
            attribute float aVatU;
            ` + shader.vertexShader;
            shader.vertexShader = shader.vertexShader.replace(
                '#include <begin_vertex>',
                vatDepthChunk,
            );
            this._contactShadowShaderRef = shader;
        };
        contactShadowMat.customProgramCacheKey = () => `poyon_contact_shadow_${this._index}`;
        this._mesh.userData.contactShadowMaterial = contactShadowMat;

        this.scene.add(this._mesh);

        // ロード完了時点で既にモードが変わっていた場合に適用
        if (this._viewMode !== 'normal') this.setViewMode(this._viewMode);

        // 読み込み完了コールバック
        this.onReady?.();
    }
    public onReady: (() => void) | null = null;
    _getPixel(x: number, y: number) {
        const data = this._positionTex.source.data.data;
        const width = this._positionTex.source.data.width;
        const height = this._positionTex.source.data.height;
        const i = (y * width + x) * 4;
        return [
            data[i],
            data[i+1],
            data[i+2],
            data[i+3],
        ];
    }

    private _debugTex(){
        const geo = new THREE.PlaneGeometry(this._w/10,this._w/10,1,1);
        const mat = new THREE.ShaderMaterial({
            uniforms: {
                uPositionTex: {value: this._positionTex},
            },
            vertexShader:devVert,
            fragmentShader:devFra,
        });
        const mesh= new THREE.Mesh(geo, mat);
        mesh.position.set(-this._w/2+this._w/20,this._h/2-this._w/20,0);
        this.scene.add(mesh);
    }
    resized(): void {

    }
    setP(p){
        if (this._shaderRef) {
            // this._material.uniforms.uTime.value = p;
            // this._shaderRef.uniforms.uTime.value = p;
        }
    }
    setMarbleColor(key: 'cyan' | 'blue' | 'pink' | 'light' | 'deep', hex: string) {
        if (!this._shaderRef) return;
        const map = {
            cyan:  'uColorCyan',
            blue:  'uColorBlue',
            pink:  'uColorPink',
            light: 'uColorLight',
            deep:  'uColorDeep',
        };
        if (this._shaderRef.uniforms[map[key]]) this._shaderRef.uniforms[map[key]].value.set(hex);
    }
    // 共通パレット生成: _mood で「淡い系(quiet)」と「派手系(loud)」を強制的に分離
    // Canvas 側で6個中 2個を quiet / 4個を loud に振り分けることで、毎回 quiet と loud の両方が見える
    private _generatePaletteFromSeed(seed: number, count: 2 | 3): THREE.Color[] {
        const fract = (v: number) => v - Math.floor(v);
        const hash  = (s: number, salt: number) => fract(Math.sin(s * 127.1 + salt) * 43758.545);
        const baseHue = fract((seed * 0.618033988749895) + this._hueOffset + this._variant * 0.5);

        let offsets: [number, number];
        let satArr: [number, number, number], lightArr: [number, number, number];

        if (this._mood === 'quiet') {
            // ほぼ白 + 薄パステル
            const patternIdx = Math.floor(hash(seed, 11.31) * 3);
            switch (patternIdx) {
                case 0: offsets = [0.08, 0.92]; break;
                case 1: offsets = [0.25, 0.50]; break;
                default: offsets = [0.50, 0.55]; break;
            }
            satArr   = [0.10, 0.50, 0.35];
            lightArr = [0.94, 0.82, 0.88];
        } else if (this._mood === 'soft') {
            // 柔らかいパステル: 類似色や直角配色で穏やかな組合せ
            const patternIdx = Math.floor(hash(seed, 11.31) * 3);
            switch (patternIdx) {
                case 0: offsets = [0.08, 0.92]; break; // 類似色
                case 1: offsets = [0.25, 0.50]; break; // 直角
                default: offsets = [0.50, 0.55]; break; // 補色（彩度低めなので穏やか）
            }
            satArr   = [0.55, 0.70, 0.50];
            lightArr = [0.78, 0.68, 0.75];
        } else if (this._mood === 'vivid') {
            // ド派手: 彩度最大、補色/三角/近接グラデ
            const patternIdx = Math.floor(hash(seed, 11.31) * 3);
            switch (patternIdx) {
                case 0: offsets = [0.50, 0.58]; break;
                case 1: offsets = [0.33, 0.67]; break;
                default: offsets = [0.10, 0.92]; break;
            }
            satArr   = [1.00, 1.00, 1.00];
            lightArr = [0.62, 0.55, 0.62];
        } else {
            // mid: ほどほどカラフル（彩度高めだが vivid よりはマイルド）
            const patternIdx = Math.floor(hash(seed, 11.31) * 3);
            switch (patternIdx) {
                case 0: offsets = [0.50, 0.55]; break;
                case 1: offsets = [0.33, 0.67]; break;
                default: offsets = [0.42, 0.58]; break;
            }
            satArr   = [0.85, 0.92, 0.78];
            lightArr = [0.66, 0.55, 0.62];
        }

        // index 0 は transmission で色が薄まるので彩度↑＆明度↓して濃いめに（quiet 以外）
        // _ultraClear モードはブースト控えめにして透明感を活かす
        if (this._index === 0 && this._mood !== 'quiet') {
            const baseSatBoost   = this._mood === 'soft' ? 0.20 : 0.10;
            const baseLightDrop  = this._mood === 'soft' ? 0.18 : 0.12;
            const boostScale = 0.7 + hash(this._instanceSeed, 17.3) * 0.7; // 0.7〜1.4 (色しっかり)
            const satBoost  = baseSatBoost  * boostScale;
            const lightDrop = baseLightDrop * boostScale;
            satArr   = [Math.min(1, satArr[0] + satBoost),   Math.min(1, satArr[1] + satBoost),   Math.min(1, satArr[2] + satBoost)];
            lightArr = [Math.max(0.30, lightArr[0] - lightDrop), Math.max(0.30, lightArr[1] - lightDrop), Math.max(0.30, lightArr[2] - lightDrop)];
        }

        const colors: THREE.Color[] = [];
        for (let i = 0; i < count; i++) {
            const h = i === 0 ? baseHue : fract(baseHue + offsets[i - 1]);
            const s = Math.max(0, Math.min(1, satArr[i]   + (hash(seed, 2.0 + i * 3) - 0.5) * 0.10));
            const l = Math.max(0, Math.min(1, lightArr[i] + (hash(seed, 5.0 + i * 3) - 0.5) * 0.04));
            colors.push(new THREE.Color().setHSL(h, s, l));
        }
        return colors;
    }

    // index 0 用: 3色パレット
    private _generateBlobPalette(seed: number): [THREE.Color, THREE.Color, THREE.Color] {
        const cols = this._generatePaletteFromSeed(seed, 3);
        return [cols[0], cols[1], cols[2]];
    }

    private _applyLoopPreset(phase: number) {
        // 個体シードとループカウントを組み合わせて個体差を出す
        const uniqueSeed = this._loopWrapCount + this._instanceSeed;

        // index=0 はプリセット配列を使わずループカウントで無限ランダムパレット
        if (this._index === 0 && this._shaderRef) {
            const [cyan, blue, pink] = this._generateBlobPalette(uniqueSeed);
            if (this._shaderRef.uniforms.uColorCyan) this._shaderRef.uniforms.uColorCyan.value.copy(cyan);
            if (this._shaderRef.uniforms.uColorBlue) this._shaderRef.uniforms.uColorBlue.value.copy(blue);
            if (this._shaderRef.uniforms.uColorPink) this._shaderRef.uniforms.uColorPink.value.copy(pink);
            return;
        }
        const p = this._loopPresets[phase];
        if (!p) return;
        if (this._index === 1) {
            const mat = this._material as THREE.MeshPhysicalMaterial;
            const seed1 = uniqueSeed;
            const fract = (v: number) => v - Math.floor(v);
            const hash  = (s: number, salt: number) => fract(Math.sin(s * 127.1 + salt) * 43758.545);

            // 色は共通ヘルパーでムード混在の2色組合せを生成
            const [bodyCol, sheenCol] = this._generatePaletteFromSeed(seed1, 2);
            mat.color.copy(bodyCol);
            mat.sheenColor?.copy(sheenCol);

            // 質感モード（3種をランダムで切り替え。下限を底上げして暗化を防ぐ）
            const modeIndex = Math.floor(hash(seed1, 5.917) * 3);
            switch (modeIndex) {
                case 0: // 微マット（envMapを下げすぎない）
                    mat.roughness          = 0.75;
                    mat.metalness          = 0.0;
                    mat.sheen              = 0.2;
                    mat.clearcoat          = 0.0;
                    mat.envMapIntensity    = 0.55;
                    break;
                case 1: // しゃりしゃり（サテン・微光沢）
                    mat.roughness          = 0.50;
                    mat.metalness          = 0.05;
                    mat.sheen              = 1.0;
                    mat.sheenRoughness     = 0.4;
                    mat.clearcoat          = 0.2;
                    mat.clearcoatRoughness = 0.3;
                    mat.envMapIntensity    = 0.7;
                    break;
                case 2: // 金属っぽい（控えめ）
                    mat.roughness          = 0.40;
                    mat.metalness          = 0.55;
                    mat.sheen              = 0.3;
                    mat.sheenRoughness     = 0.5;
                    mat.clearcoat          = 0.4;
                    mat.clearcoatRoughness = 0.15;
                    mat.envMapIntensity    = 0.95;
                    break;
            }
            mat.needsUpdate = true;
        } else if (this._index === 2 && this._shaderRef) {
            // 色を共通ヘルパーで無限生成（白+薄色 / パステル / ビビッドを混在）
            const seed = uniqueSeed;
            const fract = (v: number) => v - Math.floor(v);
            const hash  = (s: number, salt: number) => fract(Math.sin(s * 127.1 + salt) * 43758.545);
            const [lightCol, deepCol] = this._generatePaletteFromSeed(seed, 2);
            this._shaderRef.uniforms.uColorLight.value.copy(lightCol);
            this._shaderRef.uniforms.uColorDeep.value.copy(deepCol);
            const sharpBase = this._variant === 0 ? 0.4 : 0.75;
            this._shaderRef.uniforms.uSpotSharpness.value = sharpBase + hash(seed, 9.13) * 0.2;

            // 質感: 4巡に1回マット系、ただし envMap 下限を底上げして暗化させない
            const isMatte = (seed % 4) === 0;
            const mat = this._material as THREE.MeshPhysicalMaterial;
            if (isMatte) {
                mat.roughness          = 0.75;
                mat.metalness          = 0.0;
                mat.clearcoat          = 0.0;
                mat.envMapIntensity    = 0.55;
            } else {
                mat.roughness          = 0.25;
                mat.metalness          = 0.0;
                mat.clearcoat          = 0.6;
                mat.clearcoatRoughness = 0.05;
                mat.envMapIntensity    = 0.95;
            }
            mat.needsUpdate = true;
        }
    }
    setLoopPreset(phase: number, preset: {
        cyan?: string; blue?: string; pink?: string;
        color?: string; sheenColor?: string;
        light?: string; deep?: string; sharpness?: number;
    }) {
        this._loopPresets[phase] = { ...this._loopPresets[phase], ...preset };
    }
    setSpotSharpness(val: number) {
        if (this._shaderRef?.uniforms.uSpotSharpness)
            this._shaderRef.uniforms.uSpotSharpness.value = val;
    }
    setViewMode(mode: 'normal' | 'wireframe' | 'noMaterial'): void {
        this._viewMode = mode;
        if (!this._mesh) return;
        if (mode === 'normal') {
            this._mesh.material = this._material;
        } else if (mode === 'wireframe') {
            this._mesh.material = this._wireMaterial;
        } else {
            this._mesh.material = this._noMatMaterial!;
        }
    }

    updated(): void {
        // this.time += .5;
        const now = performance.now();
        const delta = (now - this._lastTime) / 16.667;
        this._lastTime = now;
        if (this._shaderRef) {

            //クリックで波紋
            this._ripples.forEach((ripple, i) => {
                if (!ripple.active) return;
                ripple.time += 1;

                const maxTime = this._shaderRef.uniforms.uRippleRadius.value
                    / this._shaderRef.uniforms.uRippleSpeed.value;

                if (ripple.time > maxTime) {
                    ripple.active = false;
                    if (this._shaderRef) {
                        this._shaderRef.uniforms.uRippleActive.value[i] = 0;
                        this._shaderRef.uniforms.uRippleTime.value[i]   = 0;
                    }
                    return;
                }

                if (this._shaderRef) {
                    this._shaderRef.uniforms.uRippleTime.value[i] = ripple.time;
                }
            });

            this.time += this._timeSpeed * delta;

            // 1ループ目: time < 0 の間は非表示、0到達で表示開始
            if (this._firstLoop) {
                if (this.time < 0) {
                    if (this._mesh) this._mesh.visible = false;
                    return;
                }
                // time が 0 以上になった → 入場
                if (this._mesh && !this._mesh.visible) this._mesh.visible = true;
                // wrapPeriod到達で1ループ目終了 → 以降通常ループ
                if (this._wrapPeriod > 0 && this.time >= this._wrapPeriod) {
                    this._firstLoop = false;
                    this.time -= this._wrapPeriod;
                    this._loopWrapCount++;
                    this._applyLoopPreset((this._loopWrapCount + this._instanceSeed) % this._loopPresets.length);
                }
            } else {
                // 通常ループ
                if (this._wrapPeriod > 0 && this.time >= this._wrapPeriod) {
                    this.time -= this._wrapPeriod;
                    this._loopWrapCount++;
                    this._applyLoopPreset((this._loopWrapCount + this._instanceSeed) % this._loopPresets.length);
                }
            }

            this._shaderRef.uniforms.uTime.value = this.time;
            if (this._depthShaderRef) {
                this._depthShaderRef.uniforms.uTime.value = this.time;
            }
            if (this._contactShadowShaderRef) {
                this._contactShadowShaderRef.uniforms.uTime.value = this.time;
            }
        }
    }
}
